export const IgnoreInputsNotBeenSetBeforeRenderWarningSymbol = Symbol('key for ignoring inputs not having been set yet');
export const defaultDeclarativeElementDefinitionOptions = {
    [IgnoreInputsNotBeenSetBeforeRenderWarningSymbol]: true,
};
